import { useCustomerSession, useCustomerQuery } from '@graphcommerce/magento-customer'
import { ProductItemsFragment } from '../../graphql/ProductItems.gql'
import { UseCustomerProductPricesDocument } from './UseCustomerProductPrices.gql'

type Product = ProductItemsFragment | undefined | null

export function useCustomerProductPriceSingle<T extends Product>(product: T): T {
  const { loggedIn } = useCustomerSession()

  const { data } = useCustomerQuery(UseCustomerProductPricesDocument, {
    variables: { skus: [product?.sku ?? 'INVALID SKU'], pageSize: 1 },
    fetchPolicy: 'cache-and-network',
  })

  if (!loggedIn || !product || !data) {
    return product
  }

  return {
    ...product,
    price_range: {
      ...data?.products?.items?.[0]?.price_range,
    } as T,
  }
}
